import api from '../api';
import router from "../../routes";
import {ElMessage} from "element-plus";

export default {
    namespaced: true,
    state: {
        loading: false,
        error: "",
        user_activity_logs: {},
        activity_summary: {},
        user: {
            modules: []
        },
        users: {data: [], current_page: 1, total: 0, per_page: 50},
        users_all: [],
        user_route_frequencies: {data: [], current_page: 1, total: 0, per_page: 50},
        user_modules: {},
        user_regions: {},
        user_products: {},
        user_categories: {},
        excel: false,
        has_errors: false,
        edit_user: {},
        errors: {
            data: {
                errors: {
                    name: [],
                    email: [],
                    phone: [],
                    user_type_id: [],
                    role_group_id: [],
                    user_team_id: [],
                    user_channel_id: [],
                    country_id: [],
                    region_id: [],
                    price_list_id: []
                }
            }
        },
        user_teams: [],
        user_suppliers: [],
        user_companies: [],
        supervisors: []
    },
    getters: {
        loggedIn() {
            return !!window.localStorage.getItem('app_token');
        },
        user: state => state.user,
        users: state => state.users,
        excel: state => state.excel,
        has_errors: state => state.has_errors,
        errors: state => state.errors,
        error: state => state.error,
        loading: state => state.loading,
        activity_summary: state => state.activity_summary
    },
    mutations: {
        hasErrors(state, has_errors) {
            state.has_errors = has_errors
        },
        setErrors(state, errors) {
            state.errors = errors
            if (!errors) {
                state.errors = {
                    name: [],
                    email: [],
                    phone: [],
                    user_type_id: [],
                    role_group_id: [],
                    user_team_id: [],
                    user_channel_id: [],
                    country_id: [],
                    region_id: [],
                    price_list_id: []
                }

            }
        },
        setUser(state, user) {
            state.user = user;
        },
        setLoading(state, val) {
            state.loading = val;
        },
        setEditUser(state, user) {
            state.edit_user = user;
        },
        setUsers(state, users) {
            if (users.total) {
                state.users = users;
            } else {
                state.users_all = users;
            }
        },

        setActivitySummary(state, summary) {
            state.activity_summary = summary
        }

    },
    actions: {


        async authenticate({commit}, credentials) {
            try {
                commit("setLoading", true)
                commit('hasErrors', false)
                const response = await api.login(credentials);
                await localStorage.setItem('app_token', response?.user?.token);
                await localStorage.setItem('user', JSON.stringify(response?.user));
                commit('setUser', (response?.user));
                ElMessage.success({
                    message: "Successfully Logged In!",
                    offset: 300
                })
                window.location.href = '/dashboard'
                commit("setLoading", false)
            } catch (e) {
                commit('hasErrors', true)
                commit('setErrors', e?.response)
                ElMessage.error({
                    message: "The credentials provided are incorrect.",
                    offset: 300
                })
                commit("setLoading", false)
            }
        },
        async validateGoogleLogin({commit}, credentials) {
            try {
                commit("setLoading", true)
                const response = await api.validateGoogleLogin(credentials);
                await localStorage.setItem('app_token', response?.user?.token);
                await localStorage.setItem('user', JSON.stringify(response?.user));
                commit('setUser', (response?.user));
                ElMessage.success({
                    message: "Successfully Logged In!",
                    offset: 300
                })
                commit("setLoading", false)
            } catch (e) {
                ElMessage.error({
                    message: "The credentials provided are incorrect.",
                    offset: 300
                })
                commit("setLoading", false)
                commit('hasErrors', true)
                commit('setErrors', e.response)
            }
        },
        async getProfile({commit}, filters = {}) {
            try {
                const response = await api.getProfile(filters);
                commit('setUser', response?.data);
            } catch (e) {
                alert("Whoops! you're not logged in. Please login to continue.")
                window.location.href = "/auth"
            }
        },
        async logout(context, filters = {}) {
            await api.logout(filters);
            localStorage.removeItem('app_token');
            window.location.href = '/auth';
        },
        async sendResetPasswordLink(context, credentials) {
            try {
                await api.sendResetPasswordLink(credentials);
            } catch (e) {
                alert(e.response.data.message);
            }
        },
        // Errors are propagated (not swallowed) rather than alert()'d -
        // VerifyEmail.vue renders success/failure states itself.
        async verifyEmailToken(context, token) {
            return await api.verifyEmail(token);
        },
        async resendEmailVerification() {
            return await api.resendEmailVerification();
        },
        async getUsers({commit}, filters) {
            try {
                commit('activateLoading', 'users/list', {root: true});
                const response = await api.getUsers(filters);
                commit('setUsers', response);
                commit('deactivateLoading', 'users/list', {root: true});
            } catch (e) {
                commit('activateLoading', 'users/list', {root: true});
                ElMessage.error('Error fetching users!');
            }
        },
        async getUser({commit}, filters) {
            try {
                commit('activateLoading', 'users/list', {root: true});
                const response = await api.getUser(filters);
                commit('setEditUser', response.data);
                commit('deactivateLoading', 'users/list', {root: true});
            } catch (e) {
                commit('activateLoading', 'users/list', {root: true});
                ElMessage.error('Error fetching user!');
            }
        },
        async getActivitySummary({commit}, filters) {
            try {
                commit('activateLoading', 'users/list', {root: true});
                const response = await api.getActivitySummary(filters);
                commit('setActivitySummary', response);
                commit('deactivateLoading', 'users/list', {root: true});
            } catch (e) {
                commit('activateLoading', 'users/list', {root: true});
                ElMessage.error('Error fetching user!');
            }
        },
        async createUser({commit}, data) {
            try {
                await api.createUser(data);
                ElMessage.success('User added successfully!');
                commit('hasErrors', false)
                await router.replace('/users');
            } catch (e) {
                ElMessage.error(e.response.data.message);
                commit('hasErrors', true);
                commit('setErrors', e.response)
            }
        },
        async editUser({commit}, data) {
            try {
                await api.editUser(data);
                await router.replace('/users');
                ElMessage.success('User updated successfully!');
                commit('hasErrors', false)
            } catch (e) {
                ElMessage.error('Error updating user!');
            }
        },

    }
};
